import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";

interface NotFoundProps {
  /** Remplace le libelle generique (ex : article introuvable). */
  titre?: string;
  message?: string;
}

/**
 * Page 404 du SPA.
 *
 * Le fallback serveur renvoie HTTP 404 pour une absence confirmee.
 * Le noindex couvre aussi les navigations internes du client React.
 */
const NotFound = ({
  titre = "Page introuvable",
  message = "Cette adresse ne mene nulle part. Elle a peut-etre change, ou le lien qui vous a amene ici est errone.",
}: NotFoundProps) => {
  const location = useLocation();

  useEffect(() => {
    console.warn("404 :", location.pathname);
  }, [location.pathname]);

  return (
    <div className="relative z-10 min-h-screen flex flex-col">
      <Helmet>
        <title>{titre} | Tokam Darius</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Header />
      <main className="flex-1 flex items-center justify-center px-6 py-24">
        <div className="max-w-md text-center">
          <p className="text-sm font-mono tracking-widest text-muted-foreground mb-4">
            ERREUR 404
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4">{titre}</h1>
          <p className="text-muted-foreground mb-8">{message}</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild>
              <Link to="/">Retour a l'accueil</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/blog">Voir le blog</Link>
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
